// Administração > Comunicação > Falha de Comunicação — avisa por
// WhatsApp o cliente vinculado a um veículo que ficou offline por mais de
// X horas. Limite ÚNICO por empresa (não por veículo). Mesmo padrão de
// gpsdrive-welcome-message.service.ts.
import { gpsDriveGet, gpsDrivePost, gpsDrivePut } from "@/lib/api/gpsdrive-client";

export interface CommunicationFailureSettings {
  enabled: boolean;
  thresholdHours: number;
  // Texto do aviso com variáveis {{placa}}/{{veiculo}}/{{cliente}}/
  // {{horas}}/{{data}} — ver COMMUNICATION_FAILURE_TEMPLATE_VARIABLES no
  // componente da tela. Sempre vem preenchido (default do backend quando
  // a empresa nunca customizou).
  messageTemplate: string;
  // Agenda de envio (pedido 2026-09-27) — ver
  // communication-failure-schedule.ts no backend. Horários de Brasília.
  scheduleMode: "imediato" | "horarios";
  sendDays: number[]; // 0 = domingo … 6 = sábado
  windowStart: string; // "HH:MM" (modo imediato)
  windowEnd: string;
  sendTimes: string[]; // "HH:MM" (modo horarios)
  maxSends: number; // 0 = até voltar a comunicar
  repeatIntervalHours: number; // só no modo imediato
  messageDelaySeconds: number;
}

export type UpdateCommunicationFailureInput = CommunicationFailureSettings;

export interface TestSendCommunicationFailureInput {
  phone: string;
  // Testa o texto ainda não salvo (o que está no campo da tela) sem
  // precisar clicar em Salvar antes.
  messageTemplate?: string;
}

export const gpsDriveCommunicationFailureService = {
  get: () => gpsDriveGet<CommunicationFailureSettings>("/api/v1/admin/communication-failure"),
  update: (input: UpdateCommunicationFailureInput) =>
    gpsDrivePut<CommunicationFailureSettings>("/api/v1/admin/communication-failure", input),
  testSend: (input: TestSendCommunicationFailureInput) =>
    gpsDrivePost<{ sent: true }>("/api/v1/admin/communication-failure/test", input),
};
